import { api } from "../APIConfigs";
import { defineCancelApiObject } from "../APIUtils";

export const LookUpAPIs = {

    GetCountries: async function (cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/countries',
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },
    GetDestinations: async function (cancel = false){
        const response = await api.request({
            url: '/school-tour-company/rest/portal/destinations',
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            signal: cancel ? cancelAPIObject[this.GetPortalAccount.name].handleRequestCancelation().signal : undefined,
        })

        return {
            data: response.data,
            status: response.status,
            statusText: response.statusText
        }
    },
    

    
}
const cancelAPIObject = defineCancelApiObject(LookUpAPIs)